export default __webpack_public_path__ + "static/media/product23_sportshoe.64fc6ef1.webp";